import { clearResults } from 'store/results/results';

export const OPTIMISTIC_UPDATE_DATE_LISTED_CLICKED = 'OPTIMISTIC_UPDATE_DATE_LISTED_CLICKED';
export const OPTIMISTIC_UPDATE_SALARY_MAX_CLICKED = 'OPTIMISTIC_UPDATE_SALARY_MAX_CLICKED';
export const OPTIMISTIC_UPDATE_SALARY_MIN_CLICKED = 'OPTIMISTIC_UPDATE_SALARY_MIN_CLICKED';
export const OPTIMISTIC_UPDATE_WORK_TYPE_CLICKED = 'OPTIMISTIC_UPDATE_WORK_TYPE_CLICKED';

function optimisticRefinement(options, { label, multiSelect }) {
  const currentlySelected = option => Boolean(option.isActive);
  const willBeSelected = option => option.label === label;
  const selectedAndNoRefineParams = option => currentlySelected(option) && typeof option.refineParams === 'undefined';
  const toggleIsActive = option => willBeSelected(option) ? !option.isActive : option.isActive;
  const calculateRefineParams = option => !selectedAndNoRefineParams(option) ? option.refineParams : {};

  // create new props
  const out = options.map(option => ({
    ...option,
    refineParams: calculateRefineParams(option),
    isActive: !multiSelect ? willBeSelected(option) : toggleIsActive(option)
  }));
  return out;
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case OPTIMISTIC_UPDATE_DATE_LISTED_CLICKED: {
      return {
        ...state,
        dateRange: optimisticRefinement(state.dateRange, action.payload)
      };
    }

    case OPTIMISTIC_UPDATE_SALARY_MAX_CLICKED: {
      return {
        ...state,
        salary: {
          ...state.salary,
          to: optimisticRefinement(state.salary.to, action.payload)
        }
      };
    }

    case OPTIMISTIC_UPDATE_SALARY_MIN_CLICKED: {
      return {
        ...state,
        salary: {
          ...state.salary,
          from: optimisticRefinement(state.salary.from, action.payload)
        }
      };
    }

    case OPTIMISTIC_UPDATE_WORK_TYPE_CLICKED: {
      return {
        ...state,
        worktype: optimisticRefinement(state.worktype, action.payload)
      };
    }

    default: {
      return state;
    }
  }
}

const runOnNextFrame = func => (...args) => new Promise(resolve => {
  if(ENV.CLIENT) {
    window.requestAnimationFrame(() => {
      resolve(func(...args));
    });
  } else {
    resolve(func(...args));
  }
});

const waitForNextFrame = runOnNextFrame(() => {});

// Dispatch refinement event with type and payload promisified
const refinementClicked = type => ({ label, multiSelect }) => {
  return dispatch => {
    const optimisticAction = { type, payload: { label, multiSelect } };
    return Promise.resolve(dispatch(optimisticAction))
      .then(runOnNextFrame(() => dispatch(clearResults())))
      .then(waitForNextFrame); // Delay browser change until next frame
  };
};

export const optimisticUpdateDateListedClicked = refinementClicked(OPTIMISTIC_UPDATE_DATE_LISTED_CLICKED);
export const optimisticUpdateSalaryMaxClicked = refinementClicked(OPTIMISTIC_UPDATE_SALARY_MAX_CLICKED);
export const optimisticUpdateSalaryMinClicked = refinementClicked(OPTIMISTIC_UPDATE_SALARY_MIN_CLICKED);
export const optimisticUpdateWorkTypeClicked = refinementClicked(OPTIMISTIC_UPDATE_WORK_TYPE_CLICKED);



/** WEBPACK FOOTER **
 ** ./app/store/search/optimistic/refinement.js
 **/